import { SET_MODAL, SET_STICKY_NAV_VISIBILITY, SET_VIDEO_OVERLAY } from 'state/actions/viewActions';

const initialViewState = {
  modal: { body: null },
  stickyNav: { isVisible: false },
  videoOverlay: { isVisible: false },
};

export default function applicationState(state = initialViewState, action) {
  switch (action.type) {
    case SET_MODAL: return { ...state, modal: { ...state.modal, ...action.payload } };
    case SET_STICKY_NAV_VISIBILITY: return { ...state, stickyNav: { ...state.stickyNav, isVisible: action.payload } };
    case SET_VIDEO_OVERLAY: return { ...state, videoOverlay: { ...state.videoOverlay, isVisible: action.payload } };
    default: return state;
  }
}



// WEBPACK FOOTER //
// ./src/state/reducers/viewReducer.js